<template>
  <div>
    <div data-elementor-type="wp-page" data-elementor-id="8" class="elementor elementor-8" data-elementor-settings="[]">
      <div class="elementor-section-wrap">
        <section
          class="elementor-section elementor-top-section elementor-element elementor-element-fb9b87b elementor-reverse-mobile elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="fb9b87b" data-element_type="section"
          data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
          <div class="elementor-background-overlay"></div>
          <div class="elementor-container elementor-column-gap-default">
            <div
              class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-a2d00b8 elementor-invisible"
              data-id="a2d00b8" data-element_type="column"
              data-settings="{&quot;animation&quot;:&quot;fadeInLeft&quot;}">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div class="elementor-element elementor-element-11dcc4b elementor-widget elementor-widget-heading"
                  data-id="11dcc4b" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h5 class="elementor-heading-title elementor-size-default" v-html="$t('home.html_do_our_best_to')">
                    </h5>
                  </div>
                </div>
                <div class="elementor-element elementor-element-c303178 elementor-widget elementor-widget-heading"
                  data-id="c303178" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h1 class="elementor-heading-title elementor-size-default" v-html="$t('home.html_secure_critical')">
                    </h1>
                  </div>
                </div>
                <div class="elementor-element elementor-element-595d2f3 elementor-widget elementor-widget-text-editor"
                  data-id="595d2f3" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container">{{$t('home.we_bring_the_best')}}</div>
                </div>
                <div
                  class="elementor-element elementor-element-8f0d56e elementor-widget__width-auto elementor-widget elementor-widget-button"
                  data-id="8f0d56e" data-element_type="widget" data-widget_type="button.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-button-wrapper"> <a href="https://github.com/CyberZ-vn/" target="_blank"
                        class="elementor-button-link elementor-button elementor-size-md elementor-animation-float"
                        role="button"> <span class="elementor-button-content-wrapper"> <span
                            class="elementor-button-text">{{$t('home.discover_more')}}</span> </span> </a></div>
                  </div>
                </div>
                <div
                  class="elementor-element elementor-element-951ddb2 elementor-widget__width-auto elementor-widget elementor-widget-button"
                  data-id="951ddb2" data-element_type="widget" data-widget_type="button.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-button-wrapper"> <a target="_blank"
                        href="https://www.youtube.com/channel/UCNrl2GzZatqkocH2h6G7c7w"
                        class="elementor-button-link elementor-button elementor-size-sm elementor-animation-float"
                        role="button"> <span class="elementor-button-content-wrapper"> <span
                            class="elementor-button-icon elementor-align-icon-left"> <i aria-hidden="true"
                              class="fas fa-play"></i> </span> <span class="elementor-button-text"></span> </span> </a>
                    </div>
                  </div>
                </div>
                <div class="elementor-element elementor-element-df8cdc4 elementor-widget elementor-widget-spacer"
                  data-id="df8cdc4" data-element_type="widget" data-widget_type="spacer.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-spacer">
                      <div class="elementor-spacer-inner"></div>
                    </div>
                  </div>
                </div>
                <section
                  class="elementor-section elementor-inner-section elementor-element elementor-element-f26915d elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="f26915d" data-element_type="section">
                  <div class="elementor-container elementor-column-gap-default">
                    <div
                      class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-e8cd66b elementor-hidden-mobile"
                      data-id="e8cd66b" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div
                          class="elementor-element elementor-element-29f205c elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                          data-id="29f205c" data-element_type="widget" data-widget_type="divider.default">
                          <div class="elementor-widget-container">
                            <div class="elementor-divider"> <span class="elementor-divider-separator"> </span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-23f2087"
                      data-id="23f2087" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div
                          class="elementor-element elementor-element-22ec76b e-grid-align-left e-grid-align-mobile-center elementor-shape-rounded elementor-grid-0 elementor-widget elementor-widget-social-icons"
                          data-id="22ec76b" data-element_type="widget" data-widget_type="social-icons.default">
                          <div class="elementor-widget-container">
                            <div class="elementor-social-icons-wrapper elementor-grid">
                              <span class="elementor-grid-item">
                                <a class="elementor-icon elementor-social-icon elementor-social-icon-facebook-f elementor-animation-float elementor-repeater-item-c218504"
                                  target="_blank" href="https://facebook.com/CyberZ.vn.sol"> <span
                                    class="elementor-screen-only">Facebook-f</span> <i class="fab fa-facebook-f"></i>
                                </a> </span>
                              <span class="elementor-grid-item"> <a
                                  class="elementor-icon elementor-social-icon elementor-social-icon-linkedin-in elementor-animation-float elementor-repeater-item-82e8f72"
                                  target="_blank" href="https://www.linkedin.com/company/cyberz-vn"> <span
                                    class="elementor-screen-only">Linkedin-in</span> <i class="fab fa-linkedin-in"></i>
                                </a> </span>
                              <span class="elementor-grid-item"> <a
                                  class="elementor-icon elementor-social-icon elementor-social-icon-github-p elementor-animation-float elementor-repeater-item-05f6869"
                                  target="_blank" href="https://github.com/CyberZ-vn"> <span
                                    class="elementor-screen-only">Github-p</span> <i class="fab fa-github"></i> </a>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
            <div
              class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-922b679 elementor-invisible"
              data-id="922b679" data-element_type="column"
              data-settings="{&quot;animation&quot;:&quot;fadeInRight&quot;,&quot;animation_mobile&quot;:&quot;fadeInRight&quot;}">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div class="elementor-element elementor-element-0dac0f2 elementor-widget elementor-widget-image"
                  data-id="0dac0f2" data-element_type="widget" data-widget_type="image.default">
                  <div class="elementor-widget-container"> <img width="543" height="598"
                      src="/wp-content/uploads/2021/11/Banner_pic_1.png"
                      class="elementor-animation-float attachment-large size-large" alt="" loading="lazy"
                      srcset="/wp-content/uploads/2021/11/Banner_pic_1.png 543w, /wp-content/uploads/2021/11/Banner_pic_1-272x300.png 272w"
                      sizes="(max-width: 543px) 100vw, 543px" /></div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section v-if="latestPosts.length != 0 "
          class="elementor-section elementor-top-section elementor-element elementor-element-5bc30b9 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="5bc30b9" data-element_type="section"
          data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
          <div class="elementor-container elementor-column-gap-default">
            <!-- <div
              class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-2ab156b elementor-invisible"
              data-id="2ab156b" data-element_type="column"
              data-settings="{&quot;animation&quot;:&quot;fadeInRight&quot;}">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div
                  class="elementor-element elementor-element-e07ed1c elementor-widget__width-auto elementor-widget elementor-widget-text-editor"
                  data-id="e07ed1c" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container"> BLOG</div>
                </div>
                <div class="elementor-element elementor-element-996dd1c elementor-widget elementor-widget-text-editor"
                  data-id="996dd1c" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container" style="cursor: pointer;"> Cum sociis natoque penatibus et
                    magnisd is parturient montes
                    nasc.</div>
                </div>
                <div class="elementor-element elementor-element-7041927 elementor-widget elementor-widget-text-editor"
                  data-id="7041927" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container"> August 11, 2021</div>
                </div>
              </div>
            </div> -->
            <div v-for="p in latestPosts.slice(0,4)" :key="p.id"
              class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-bb47c1d elementor-invisible"
              data-id="bb47c1d" data-element_type="column"
              data-settings="{&quot;animation&quot;:&quot;fadeInRight&quot;,&quot;animation_delay&quot;:100}">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div
                  class="elementor-element elementor-element-758cf3a elementor-widget__width-auto elementor-widget elementor-widget-text-editor"
                  data-id="758cf3a" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container"> BLOG</div>
                </div>
                <a :href="p.html_url" target="_blank" rel="noopener noreferrer">
                  <div style="cursor: pointer;"
                    class="ablog-title elementor-element elementor-element-1e27ffa elementor-widget elementor-widget-text-editor"
                    data-id="1e27ffa" data-element_type="widget" data-widget_type="text-editor.default">
                    <div class="elementor-widget-container"> {{p.title}}</div>
                  </div>
                </a>
                <div class="elementor-element elementor-element-8d96c9c elementor-widget elementor-widget-text-editor"
                  data-id="8d96c9c" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container"> {{(new Date(p.created_at)).toLocaleString()}}</div>
                </div>
              </div>
            </div>
            <!-- <div
              class="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-1884c7b elementor-invisible"
              data-id="1884c7b" data-element_type="column"
              data-settings="{&quot;animation&quot;:&quot;fadeInRight&quot;,&quot;animation_delay&quot;:200}">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div
                  class="elementor-element elementor-element-8e56812 elementor-widget__width-auto elementor-widget elementor-widget-text-editor"
                  data-id="8e56812" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container"> BLOG</div>
                </div>
                <div class="elementor-element elementor-element-c6684ea elementor-widget elementor-widget-text-editor"
                  data-id="c6684ea" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container"> Cum sociis natoque penatibus et magnisd is parturient montes
                    nasc.</div>
                </div>
                <div class="elementor-element elementor-element-4c31be0 elementor-widget elementor-widget-text-editor"
                  data-id="4c31be0" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container"> August 11, 2021</div>
                </div>
              </div>
            </div> -->
          </div>
        </section>
        <!-- <section
          class="elementor-section elementor-top-section elementor-element elementor-element-ca17227 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="ca17227" data-element_type="section"
          data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
          <div class="elementor-container elementor-column-gap-default">
            <div
              class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-a08a90d"
              data-id="a08a90d" data-element_type="column">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div
                  class="elementor-element elementor-element-20c4d3d elementor-invisible elementor-widget elementor-widget-heading"
                  data-id="20c4d3d" data-element_type="widget"
                  data-settings="{&quot;_animation&quot;:&quot;fadeInDown&quot;}" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h4 class="elementor-heading-title elementor-size-default">Trusted Over 2300+ Companies in the World
                    </h4>
                  </div>
                </div>
                <section
                  class="elementor-section elementor-inner-section elementor-element elementor-element-bd236aa elementor-section-boxed elementor-section-height-default elementor-section-height-default elementor-invisible"
                  data-id="bd236aa" data-element_type="section"
                  data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div
                      class="elementor-column elementor-col-16 elementor-inner-column elementor-element elementor-element-2a5bf56"
                      data-id="2a5bf56" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-element elementor-element-47e43d9 elementor-widget elementor-widget-image"
                          data-id="47e43d9" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container"> <img width="91" height="43"
                              src="/wp-content/uploads/2021/11/Partner-1-1.png"
                              class="elementor-animation-float attachment-large size-large" alt="" loading="lazy" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-16 elementor-inner-column elementor-element elementor-element-01c4b92"
                      data-id="01c4b92" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-element elementor-element-eb0fc67 elementor-widget elementor-widget-image"
                          data-id="eb0fc67" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container"> <img width="116" height="40"
                              src="/wp-content/uploads/2021/11/Partner-2.png"
                              class="elementor-animation-float attachment-large size-large" alt="" loading="lazy" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-16 elementor-inner-column elementor-element elementor-element-4f6cabe"
                      data-id="4f6cabe" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-element elementor-element-847b3a6 elementor-widget elementor-widget-image"
                          data-id="847b3a6" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container"> <img width="94" height="50"
                              src="/wp-content/uploads/2021/11/Partner-3.png"
                              class="elementor-animation-float attachment-large size-large" alt="" loading="lazy" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-16 elementor-inner-column elementor-element elementor-element-4fd8d43"
                      data-id="4fd8d43" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-element elementor-element-dcc3466 elementor-widget elementor-widget-image"
                          data-id="dcc3466" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container"> <img width="126" height="41"
                              src="/wp-content/uploads/2021/11/Partner-4.png"
                              class="elementor-animation-float attachment-large size-large" alt="" loading="lazy" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-16 elementor-inner-column elementor-element elementor-element-5e2b5aa"
                      data-id="5e2b5aa" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-element elementor-element-4d4c1a0 elementor-widget elementor-widget-image"
                          data-id="4d4c1a0" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container"> <img width="114" height="26"
                              src="/wp-content/uploads/2021/11/Partner-5.png"
                              class="elementor-animation-float attachment-large size-large" alt="" loading="lazy" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-16 elementor-inner-column elementor-element elementor-element-e6c2a95"
                      data-id="e6c2a95" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-element elementor-element-9073e99 elementor-widget elementor-widget-image"
                          data-id="9073e99" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container"> <img width="106" height="50"
                              src="/wp-content/uploads/2021/11/Partner-6.png"
                              class="elementor-animation-float attachment-large size-large" alt="" loading="lazy" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section> -->
        <section id="about-us"
          class="elementor-section elementor-top-section elementor-element elementor-element-224a693 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="224a693" data-element_type="section"
          data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
          <div class="elementor-background-overlay"></div>
          <div class="elementor-container elementor-column-gap-default">
            <div
              class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-43633e6"
              data-id="43633e6" data-element_type="column">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div
                  class="elementor-element elementor-element-85eb87b elementor-invisible elementor-widget elementor-widget-heading"
                  data-id="85eb87b" data-element_type="widget"
                  data-settings="{&quot;_animation&quot;:&quot;fadeInDown&quot;}" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h3 class="elementor-heading-title elementor-size-default">{{$t('home.why_choose_us')}}</h3>
                  </div>
                </div>
                <div class="elementor-element elementor-element-cfd2a00 elementor-widget elementor-widget-text-editor"
                  data-id="cfd2a00" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container"> {{$t('home.why_choose_us_desc')}}</div>
                </div>
                <section
                  class="elementor-section elementor-inner-section elementor-element elementor-element-2025a08 elementor-section-boxed elementor-section-height-default elementor-section-height-default elementor-invisible"
                  data-id="2025a08" data-element_type="section"
                  data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div
                      class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-df3bcfb"
                      data-id="df3bcfb" data-element_type="column"
                      data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-background-overlay"></div>
                        <div
                          class="elementor-element elementor-element-8a167df elementor-widget__width-auto elementor-widget elementor-widget-image"
                          data-id="8a167df" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container"> <img width="46" height="48"
                              src="/wp-content/uploads/2021/11/Why_Choose_Us-1-1.png"
                              class="elementor-animation-shrink attachment-large size-large" alt="" loading="lazy" />
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-4048952 elementor-widget elementor-widget-heading"
                          data-id="4048952" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h4 class="elementor-heading-title elementor-size-default">{{$t('home.cybersec_expertise')}}
                            </h4>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-7918639 elementor-widget elementor-widget-text-editor"
                          data-id="7918639" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container"> {{$t('home.cybersec_expertise_desc')}}</div>
                        </div>
                        <!-- <div
                          class="elementor-element elementor-element-2542683 elementor-align-left elementor-widget elementor-widget-button"
                          data-id="2542683" data-element_type="widget" data-widget_type="button.default">
                          <div class="elementor-widget-container">
                            <div class="elementor-button-wrapper"> <a href="#"
                                class="elementor-button-link elementor-button elementor-size-xs elementor-animation-float"
                                role="button"> <span class="elementor-button-content-wrapper"> <span
                                    class="elementor-button-icon elementor-align-icon-right"> <i aria-hidden="true"
                                      class="fas fa-angle-right"></i> </span> <span class="elementor-button-text">Learn
                                    More</span> </span> </a></div>
                          </div>
                        </div> -->
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-e1cc819"
                      data-id="e1cc819" data-element_type="column"
                      data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-background-overlay"></div>
                        <div
                          class="elementor-element elementor-element-ec7c58b elementor-widget__width-auto elementor-widget elementor-widget-image"
                          data-id="ec7c58b" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container"> <img width="46" height="48"
                              src="/wp-content/uploads/2021/11/Why_Choose_Us-2.png"
                              class="elementor-animation-shrink attachment-large size-large" alt="" loading="lazy" />
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-f91317e elementor-widget elementor-widget-heading"
                          data-id="f91317e" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h4 class="elementor-heading-title elementor-size-default">{{$t('home.experience')}}</h4>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-195c441 elementor-widget elementor-widget-text-editor"
                          data-id="195c441" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container"> {{$t('home.experience_desc')}}</div>
                        </div>
                        <!-- <div
                          class="elementor-element elementor-element-a599168 elementor-align-left elementor-widget elementor-widget-button"
                          data-id="a599168" data-element_type="widget" data-widget_type="button.default">
                          <div class="elementor-widget-container">
                            <div class="elementor-button-wrapper"> <a href="#"
                                class="elementor-button-link elementor-button elementor-size-sm elementor-animation-float"
                                role="button"> <span class="elementor-button-content-wrapper"> <span
                                    class="elementor-button-icon elementor-align-icon-right"> <i aria-hidden="true"
                                      class="fas fa-angle-right"></i> </span> <span class="elementor-button-text">Learn
                                    More</span> </span> </a></div>
                          </div>
                        </div> -->
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-62ff0ff"
                      data-id="62ff0ff" data-element_type="column"
                      data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-background-overlay"></div>
                        <div
                          class="elementor-element elementor-element-11bde0c elementor-widget__width-auto elementor-widget elementor-widget-image"
                          data-id="11bde0c" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container"> <img width="46" height="48"
                              src="/wp-content/uploads/2021/11/Why_Choose_Us-3.png"
                              class="elementor-animation-shrink attachment-large size-large" alt="" loading="lazy" />
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-73b7cc0 elementor-widget elementor-widget-heading"
                          data-id="73b7cc0" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h4 class="elementor-heading-title elementor-size-default">{{$t('home.trust')}}</h4>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-8e4ebdd elementor-widget elementor-widget-text-editor"
                          data-id="8e4ebdd" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container"> {{$t('home.trust_desc')}}</div>
                        </div>
                        <!-- <div
                          class="elementor-element elementor-element-273aa3b elementor-align-left elementor-widget elementor-widget-button"
                          data-id="273aa3b" data-element_type="widget" data-widget_type="button.default">
                          <div class="elementor-widget-container">
                            <div class="elementor-button-wrapper"> <a href="#"
                                class="elementor-button-link elementor-button elementor-size-sm elementor-animation-float"
                                role="button"> <span class="elementor-button-content-wrapper"> <span
                                    class="elementor-button-icon elementor-align-icon-right"> <i aria-hidden="true"
                                      class="fas fa-angle-right"></i> </span> <span class="elementor-button-text">Learn
                                    More</span> </span> </a></div>
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
        <section
          class="elementor-section elementor-top-section elementor-element elementor-element-bfe862f elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="bfe862f" data-element_type="section"
          data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
          <div class="elementor-container elementor-column-gap-default">
            <div
              class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-9d53d8a elementor-invisible"
              data-id="9d53d8a" data-element_type="column"
              data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;animation&quot;:&quot;fadeInLeft&quot;}">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div class="elementor-element elementor-element-21387b0 elementor-widget elementor-widget-image"
                  data-id="21387b0" data-element_type="widget" data-widget_type="image.default">
                  <div class="elementor-widget-container"> <img width="891" height="600"
                      src="/wp-content/uploads/2021/11/CyberSecurity-1.jpg" class="attachment-full size-full" alt=""
                      loading="lazy"
                      srcset="/wp-content/uploads/2021/11/CyberSecurity-1.jpg 891w, /wp-content/uploads/2021/11/CyberSecurity-1-300x202.jpg 300w, /wp-content/uploads/2021/11/CyberSecurity-1-768x517.jpg 768w"
                      sizes="(max-width: 891px) 100vw, 891px" /></div>
                </div>
              </div>
            </div>
            <div
              class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-246f540 elementor-invisible"
              data-id="246f540" data-element_type="column"
              data-settings="{&quot;animation&quot;:&quot;fadeInRight&quot;}">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div
                  class="elementor-element elementor-element-69de4c0 elementor-widget__width-auto elementor-widget elementor-widget-heading"
                  data-id="69de4c0" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h3 class="elementor-heading-title elementor-size-default">{{$t('home.core_value_1')}}</h3>
                  </div>
                </div>
                <div
                  class="elementor-element elementor-element-4b41f75 elementor-widget__width-auto elementor-widget elementor-widget-heading"
                  data-id="4b41f75" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h3 class="elementor-heading-title elementor-size-default">{{$t('home.core_value_2')}}</h3>
                  </div>
                </div>
                <div
                  class="elementor-element elementor-element-266cde5 elementor-widget__width-auto elementor-widget elementor-widget-heading"
                  data-id="266cde5" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h3 class="elementor-heading-title elementor-size-default">&nbsp;{{$t('home.core_value_3')}}</h3>
                  </div>
                </div>
                <div class="elementor-element elementor-element-ea57f42 elementor-widget elementor-widget-text-editor"
                  data-id="ea57f42" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container"> {{$t('home.core_value_desc')}}</div>
                </div>
                <div class="elementor-element elementor-element-ed07b83 elementor-widget elementor-widget-text-editor"
                  data-id="ed07b83" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container"> {{$t('home.core_value_desc_2')}}</div>
                </div>
                <div
                  class="elementor-element elementor-element-cf445b1 elementor-widget__width-auto elementor-widget elementor-widget-button"
                  data-id="cf445b1" data-element_type="widget" data-widget_type="button.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-button-wrapper"> <a href="javascript:;" onclick="jQueryScroll('#contact-us')"
                        class="elementor-button-link elementor-button elementor-size-md elementor-animation-float"
                        role="button"> <span class="elementor-button-content-wrapper"> <span
                            class="elementor-button-text">{{$t('home.core_value_btn')}}</span> </span> </a></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- <section
          class="elementor-section elementor-top-section elementor-element elementor-element-701d9bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="701d9bb" data-element_type="section">
          <div class="elementor-container elementor-column-gap-default">
            <div
              class="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-cd6bbae elementor-invisible"
              data-id="cd6bbae" data-element_type="column"
              data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;animation&quot;:&quot;fadeInRight&quot;}">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div class="elementor-background-overlay"></div>
                <div
                  class="elementor-element elementor-element-44d63b0 elementor-widget__width-auto elementor-widget elementor-widget-image"
                  data-id="44d63b0" data-element_type="widget" data-widget_type="image.default">
                  <div class="elementor-widget-container"> <img width="70" height="70"
                      src="/wp-content/uploads/2021/11/Global_Projects.png"
                      class="elementor-animation-shrink attachment-large size-large" alt="" loading="lazy" /></div>
                </div>
                <div
                  class="elementor-element elementor-element-e01e858 elementor-widget-tablet__width-auto elementor-widget-mobile__width-inherit elementor-widget elementor-widget-counter"
                  data-id="e01e858" data-element_type="widget" data-widget_type="counter.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-counter">
                      <div class="elementor-counter-number-wrapper"> <span
                          class="elementor-counter-number-prefix"></span>
                        <span class="elementor-counter-number" data-duration="2000" data-to-value="3325"
                          data-from-value="0" data-delimiter=",">0</span> <span
                          class="elementor-counter-number-suffix">+</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="elementor-element elementor-element-66affb6 elementor-widget elementor-widget-heading"
                  data-id="66affb6" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h5 class="elementor-heading-title elementor-size-default">Projects</h5>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-1f60925 elementor-invisible"
              data-id="1f60925" data-element_type="column"
              data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;animation&quot;:&quot;fadeInRight&quot;}">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div class="elementor-background-overlay"></div>
                <div
                  class="elementor-element elementor-element-de2112f elementor-widget__width-auto elementor-widget elementor-widget-image"
                  data-id="de2112f" data-element_type="widget" data-widget_type="image.default">
                  <div class="elementor-widget-container"> <img width="70" height="70"
                      src="/wp-content/uploads/2021/11/Clients_Protect.png"
                      class="elementor-animation-shrink attachment-large size-large" alt="" loading="lazy" /></div>
                </div>
                <div
                  class="elementor-element elementor-element-0790b58 elementor-widget-tablet__width-auto elementor-widget-mobile__width-inherit elementor-widget elementor-widget-counter"
                  data-id="0790b58" data-element_type="widget" data-widget_type="counter.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-counter">
                      <div class="elementor-counter-number-wrapper"> <span
                          class="elementor-counter-number-prefix"></span>
                        <span class="elementor-counter-number" data-duration="2000" data-to-value="4579"
                          data-from-value="0" data-delimiter=",">0</span> <span
                          class="elementor-counter-number-suffix">+</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="elementor-element elementor-element-76c0235 elementor-widget elementor-widget-heading"
                  data-id="76c0235" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h5 class="elementor-heading-title elementor-size-default">Clients Protect</h5>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-e244d51 elementor-invisible"
              data-id="e244d51" data-element_type="column"
              data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;animation&quot;:&quot;fadeInRight&quot;}">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div class="elementor-background-overlay"></div>
                <div
                  class="elementor-element elementor-element-5412c50 elementor-widget__width-auto elementor-widget elementor-widget-image"
                  data-id="5412c50" data-element_type="widget" data-widget_type="image.default">
                  <div class="elementor-widget-container"> <img width="70" height="70"
                      src="/wp-content/uploads/2021/11/Service_Gurantee.png"
                      class="elementor-animation-shrink attachment-large size-large" alt="" loading="lazy" /></div>
                </div>
                <div
                  class="elementor-element elementor-element-147a814 elementor-widget-tablet__width-auto elementor-widget-mobile__width-inherit elementor-widget elementor-widget-counter"
                  data-id="147a814" data-element_type="widget" data-widget_type="counter.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-counter">
                      <div class="elementor-counter-number-wrapper"> <span
                          class="elementor-counter-number-prefix"></span>
                        <span class="elementor-counter-number" data-duration="2000" data-to-value="100"
                          data-from-value="0" data-delimiter=",">0</span> <span
                          class="elementor-counter-number-suffix">%</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="elementor-element elementor-element-a631f3c elementor-widget elementor-widget-heading"
                  data-id="a631f3c" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h5 class="elementor-heading-title elementor-size-default">Service Guarantee</h5>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="elementor-column elementor-col-25 elementor-top-column elementor-element elementor-element-4e1d629 elementor-invisible"
              data-id="4e1d629" data-element_type="column"
              data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;animation&quot;:&quot;fadeInRight&quot;}">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div class="elementor-background-overlay"></div>
                <div
                  class="elementor-element elementor-element-dcbef67 elementor-widget__width-auto elementor-widget elementor-widget-image"
                  data-id="dcbef67" data-element_type="widget" data-widget_type="image.default">
                  <div class="elementor-widget-container"> <img width="70" height="70"
                      src="/wp-content/uploads/2021/11/Experts_Team.png"
                      class="elementor-animation-shrink attachment-large size-large" alt="" loading="lazy" /></div>
                </div>
                <div
                  class="elementor-element elementor-element-2e022f7 elementor-widget-tablet__width-auto elementor-widget-mobile__width-inherit elementor-widget elementor-widget-counter"
                  data-id="2e022f7" data-element_type="widget" data-widget_type="counter.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-counter">
                      <div class="elementor-counter-number-wrapper"> <span
                          class="elementor-counter-number-prefix"></span>
                        <span class="elementor-counter-number" data-duration="2000" data-to-value="7845"
                          data-from-value="0" data-delimiter=",">0</span> <span
                          class="elementor-counter-number-suffix">+</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="elementor-element elementor-element-5b96835 elementor-widget elementor-widget-heading"
                  data-id="5b96835" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h5 class="elementor-heading-title elementor-size-default">Experts Team</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> -->
        <!-- <section
          class="elementor-section elementor-top-section elementor-element elementor-element-b1a9c0a elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="b1a9c0a" data-element_type="section"
          data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
          <div class="elementor-container elementor-column-gap-default">
            <div
              class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-09a6519 elementor-invisible"
              data-id="09a6519" data-element_type="column"
              data-settings="{&quot;animation&quot;:&quot;fadeInLeft&quot;}">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div
                  class="elementor-element elementor-element-38acdcd elementor-widget__width-auto elementor-widget elementor-widget-heading"
                  data-id="38acdcd" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h3 class="elementor-heading-title elementor-size-default">Providing Best</h3>
                  </div>
                </div>
                <div
                  class="elementor-element elementor-element-bfb1df1 elementor-widget__width-auto elementor-widget elementor-widget-heading"
                  data-id="bfb1df1" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h3 class="elementor-heading-title elementor-size-default">Cyber</h3>
                  </div>
                </div>
                <div
                  class="elementor-element elementor-element-6d42fd8 elementor-widget__width-auto elementor-widget elementor-widget-heading"
                  data-id="6d42fd8" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h3 class="elementor-heading-title elementor-size-default">Security</h3>
                  </div>
                </div>
                <div
                  class="elementor-element elementor-element-54dc47a elementor-widget__width-auto elementor-widget elementor-widget-heading"
                  data-id="54dc47a" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h3 class="elementor-heading-title elementor-size-default">Provider</h3>
                  </div>
                </div>
                <div class="elementor-element elementor-element-b1f22eb elementor-widget elementor-widget-text-editor"
                  data-id="b1f22eb" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container"> Lorem ipsum dolor sit amet consectetuer adipiscing elitenean
                    commo doligula eget dolorenean massa.In enim justo, rhoncus ut, imperdiet avene natis vitae justo
                    nullam dictum felis eu pede mollis pretium Inte ger tincid unt cras dapibus.</div>
                </div>
                <div class="elementor-element elementor-element-d684f06 elementor-widget elementor-widget-text-editor"
                  data-id="d684f06" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container"> Vamus elementum semper nisi aenean vulputate eleife nd tellus
                    onsec tet ueradip.</div>
                </div>
                <div
                  class="elementor-element elementor-element-69accc1 elementor-widget__width-auto elementor-widget elementor-widget-button"
                  data-id="69accc1" data-element_type="widget" data-widget_type="button.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-button-wrapper"> <a href="#"
                        class="elementor-button-link elementor-button elementor-size-md elementor-animation-float"
                        role="button"> <span class="elementor-button-content-wrapper"> <span
                            class="elementor-button-text">Contact Us</span> </span> </a></div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-9afa77d elementor-invisible"
              data-id="9afa77d" data-element_type="column"
              data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;animation&quot;:&quot;fadeInRight&quot;}">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div class="elementor-element elementor-element-5f5608e elementor-widget elementor-widget-image"
                  data-id="5f5608e" data-element_type="widget" data-widget_type="image.default">
                  <div class="elementor-widget-container"> <img width="509" height="582"
                      src="/wp-content/uploads/2021/11/Best_Solutions_Hackerman-1.jpg" class="attachment-full size-full"
                      alt="" loading="lazy"
                      srcset="/wp-content/uploads/2021/11/Best_Solutions_Hackerman-1.jpg 509w, /wp-content/uploads/2021/11/Best_Solutions_Hackerman-1-262x300.jpg 262w"
                      sizes="(max-width: 509px) 100vw, 509px" /></div>
                </div>
              </div>
            </div>
          </div>
        </section> -->
        <section id="services"
          class="elementor-section elementor-top-section elementor-element elementor-element-442f0e0 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="442f0e0" data-element_type="section"
          data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
          <div class="elementor-background-overlay"></div>
          <div class="elementor-container elementor-column-gap-default">
            <div
              class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-44bd6a9"
              data-id="44bd6a9" data-element_type="column">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div
                  class="elementor-element elementor-element-bd9a177 elementor-invisible elementor-widget elementor-widget-heading"
                  data-id="bd9a177" data-element_type="widget"
                  data-settings="{&quot;_animation&quot;:&quot;fadeInDown&quot;}" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h3 class="elementor-heading-title elementor-size-default">{{$t('home.services')}}</h3>
                  </div>
                </div>
                <div class="elementor-element elementor-element-a7ce2cb elementor-widget elementor-widget-text-editor"
                  data-id="a7ce2cb" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container"> {{$t('home.services_desc')}}</div>
                </div>
                <section
                  class="elementor-section elementor-inner-section elementor-element elementor-element-1ca09c0 elementor-section-boxed elementor-section-height-default elementor-section-height-default elementor-invisible"
                  data-id="1ca09c0" data-element_type="section"
                  data-settings="{&quot;animation&quot;:&quot;fadeInLeft&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div
                      class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-63d579b"
                      data-id="63d579b" data-element_type="column"
                      data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-background-overlay"></div>
                        <div
                          class="elementor-element elementor-element-078cccf elementor-widget__width-auto elementor-widget elementor-widget-image"
                          data-id="078cccf" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container"> <img width="70" height="70"
                              src="/wp-content/uploads/2021/11/Threat_Intelligence.png"
                              class="elementor-animation-shrink attachment-large size-large" alt="" loading="lazy" />
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-861707c elementor-widget elementor-widget-heading"
                          data-id="861707c" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h4 class="elementor-heading-title elementor-size-default">{{$t('home.services_1')}}
                            </h4>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-17838b2 elementor-widget elementor-widget-text-editor"
                          data-id="17838b2" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container"> {{$t('home.services_1_desc')}}</div>
                        </div>
                        <!-- <div
                          class="elementor-element elementor-element-fb2dfcd elementor-align-left elementor-widget elementor-widget-button"
                          data-id="fb2dfcd" data-element_type="widget" data-widget_type="button.default">
                          <div class="elementor-widget-container">
                            <div class="elementor-button-wrapper"> <a href="#"
                                class="elementor-button-link elementor-button elementor-size-sm elementor-animation-float"
                                role="button"> <span class="elementor-button-content-wrapper"> <span
                                    class="elementor-button-icon elementor-align-icon-right"> <i aria-hidden="true"
                                      class="fas fa-angle-right"></i> </span> <span class="elementor-button-text">Learn
                                    More</span> </span> </a></div>
                          </div>
                        </div> -->
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-fb24622"
                      data-id="fb24622" data-element_type="column"
                      data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-background-overlay"></div>
                        <div
                          class="elementor-element elementor-element-e83139d elementor-widget__width-auto elementor-widget elementor-widget-image"
                          data-id="e83139d" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container"> <img width="70" height="70"
                              src="/wp-content/uploads/2021/11/Security-Assessment.png"
                              class="elementor-animation-shrink attachment-large size-large" alt="" loading="lazy" />
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-0628622 elementor-widget elementor-widget-heading"
                          data-id="0628622" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h4 class="elementor-heading-title elementor-size-default">{{$t('home.services_2')}}</h4>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-ef090a0 elementor-widget elementor-widget-text-editor"
                          data-id="ef090a0" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container"> {{$t('home.services_2_desc')}}</div>
                        </div>
                        <!-- <div
                          class="elementor-element elementor-element-220b0b9 elementor-align-left elementor-widget elementor-widget-button"
                          data-id="220b0b9" data-element_type="widget" data-widget_type="button.default">
                          <div class="elementor-widget-container">
                            <div class="elementor-button-wrapper"> <a href="#"
                                class="elementor-button-link elementor-button elementor-size-sm elementor-animation-float"
                                role="button"> <span class="elementor-button-content-wrapper"> <span
                                    class="elementor-button-icon elementor-align-icon-right"> <i aria-hidden="true"
                                      class="fas fa-angle-right"></i> </span> <span class="elementor-button-text">Learn
                                    More</span> </span> </a></div>
                          </div>
                        </div> -->
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-b21af0f"
                      data-id="b21af0f" data-element_type="column"
                      data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-background-overlay"></div>
                        <div
                          class="elementor-element elementor-element-c5f7fea elementor-widget__width-auto elementor-widget elementor-widget-image"
                          data-id="c5f7fea" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container"> <img width="70" height="70"
                              src="/wp-content/uploads/2021/11/Compromise_Assessment.png"
                              class="elementor-animation-shrink attachment-large size-large" alt="" loading="lazy" />
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-150db4c elementor-widget elementor-widget-heading"
                          data-id="150db4c" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h4 class="elementor-heading-title elementor-size-default">{{$t('home.services_3')}}</h4>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-04609da elementor-widget elementor-widget-text-editor"
                          data-id="04609da" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container"> {{$t('home.services_3_desc')}}</div>
                        </div>
                        <!-- <div
                          class="elementor-element elementor-element-3d8e7a5 elementor-align-left elementor-widget elementor-widget-button"
                          data-id="3d8e7a5" data-element_type="widget" data-widget_type="button.default">
                          <div class="elementor-widget-container">
                            <div class="elementor-button-wrapper"> <a href="#"
                                class="elementor-button-link elementor-button elementor-size-sm elementor-animation-float"
                                role="button"> <span class="elementor-button-content-wrapper"> <span
                                    class="elementor-button-icon elementor-align-icon-right"> <i aria-hidden="true"
                                      class="fas fa-angle-right"></i> </span> <span class="elementor-button-text">Learn
                                    More</span> </span> </a></div>
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </section>
                <section
                  class="elementor-section elementor-inner-section elementor-element elementor-element-dd28ab0 elementor-section-boxed elementor-section-height-default elementor-section-height-default elementor-invisible"
                  data-id="dd28ab0" data-element_type="section"
                  data-settings="{&quot;animation&quot;:&quot;fadeInRight&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div
                      class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-c9c38fe"
                      data-id="c9c38fe" data-element_type="column"
                      data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-background-overlay"></div>
                        <div
                          class="elementor-element elementor-element-baab375 elementor-widget__width-auto elementor-widget elementor-widget-image"
                          data-id="baab375" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container"> <img width="70" height="70"
                              src="/wp-content/uploads/2021/11/Incident-Response.png"
                              class="elementor-animation-shrink attachment-large size-large" alt="" loading="lazy" />
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-b84b779 elementor-widget elementor-widget-heading"
                          data-id="b84b779" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h4 class="elementor-heading-title elementor-size-default">{{$t('home.services_4')}}</h4>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-8dcf251 elementor-widget elementor-widget-text-editor"
                          data-id="8dcf251" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container"> {{$t('home.services_4_desc')}}</div>
                        </div>
                        <!-- <div
                          class="elementor-element elementor-element-6007e4a elementor-align-left elementor-widget elementor-widget-button"
                          data-id="6007e4a" data-element_type="widget" data-widget_type="button.default">
                          <div class="elementor-widget-container">
                            <div class="elementor-button-wrapper"> <a href="#"
                                class="elementor-button-link elementor-button elementor-size-sm elementor-animation-float"
                                role="button"> <span class="elementor-button-content-wrapper"> <span
                                    class="elementor-button-icon elementor-align-icon-right"> <i aria-hidden="true"
                                      class="fas fa-angle-right"></i> </span> <span class="elementor-button-text">Learn
                                    More</span> </span> </a></div>
                          </div>
                        </div> -->
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-07f1d1d"
                      data-id="07f1d1d" data-element_type="column"
                      data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-background-overlay"></div>
                        <div
                          class="elementor-element elementor-element-a6bc578 elementor-widget__width-auto elementor-widget elementor-widget-image"
                          data-id="a6bc578" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container"> <img width="70" height="70"
                              src="/wp-content/uploads/2021/11/Security-Training.png"
                              class="elementor-animation-shrink attachment-large size-large" alt="" loading="lazy" />
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-4cc0ddd elementor-widget elementor-widget-heading"
                          data-id="4cc0ddd" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h4 class="elementor-heading-title elementor-size-default">{{$t('home.services_5')}}</h4>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-1759e3f elementor-widget elementor-widget-text-editor"
                          data-id="1759e3f" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container"> {{$t('home.services_5_desc')}}</div>
                        </div>
                        <!-- <div
                          class="elementor-element elementor-element-57d7821 elementor-align-left elementor-widget elementor-widget-button"
                          data-id="57d7821" data-element_type="widget" data-widget_type="button.default">
                          <div class="elementor-widget-container">
                            <div class="elementor-button-wrapper"> <a href="#"
                                class="elementor-button-link elementor-button elementor-size-sm elementor-animation-float"
                                role="button"> <span class="elementor-button-content-wrapper"> <span
                                    class="elementor-button-icon elementor-align-icon-right"> <i aria-hidden="true"
                                      class="fas fa-angle-right"></i> </span> <span class="elementor-button-text">Learn
                                    More</span> </span> </a></div>
                          </div>
                        </div> -->
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-064e108"
                      data-id="064e108" data-element_type="column"
                      data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-background-overlay"></div>
                        <div
                          class="elementor-element elementor-element-19852e9 elementor-widget__width-auto elementor-widget elementor-widget-image"
                          data-id="19852e9" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container"> <img width="70" height="70"
                              src="/wp-content/uploads/2021/11/Cloud-Security.png"
                              class="elementor-animation-shrink attachment-large size-large" alt="" loading="lazy" />
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-3b1b2e4 elementor-widget elementor-widget-heading"
                          data-id="3b1b2e4" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h4 class="elementor-heading-title elementor-size-default">{{$t('home.services_6')}}</h4>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-bf08993 elementor-widget elementor-widget-text-editor"
                          data-id="bf08993" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container"> {{$t('home.services_6_desc')}}</div>
                        </div>
                        <!-- <div
                          class="elementor-element elementor-element-a102a44 elementor-align-left elementor-widget elementor-widget-button"
                          data-id="a102a44" data-element_type="widget" data-widget_type="button.default">
                          <div class="elementor-widget-container">
                            <div class="elementor-button-wrapper"> <a href="#"
                                class="elementor-button-link elementor-button elementor-size-sm elementor-animation-float"
                                role="button"> <span class="elementor-button-content-wrapper"> <span
                                    class="elementor-button-icon elementor-align-icon-right"> <i aria-hidden="true"
                                      class="fas fa-angle-right"></i> </span> <span class="elementor-button-text">Learn
                                    More</span> </span> </a></div>
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
        <!-- <section
          class="elementor-section elementor-top-section elementor-element elementor-element-18e74e1 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="18e74e1" data-element_type="section"
          data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
          <div class="elementor-container elementor-column-gap-default">
            <div
              class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-c7004fb elementor-invisible"
              data-id="c7004fb" data-element_type="column"
              data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;animation&quot;:&quot;fadeInLeft&quot;}">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div class="elementor-element elementor-element-cde7382 elementor-widget elementor-widget-image"
                  data-id="cde7382" data-element_type="widget" data-widget_type="image.default">
                  <div class="elementor-widget-container"> <img width="509" height="546"
                      src="/wp-content/uploads/2021/11/General_Questions-1-1.jpg" class="attachment-full size-full"
                      alt="" loading="lazy"
                      srcset="/wp-content/uploads/2021/11/General_Questions-1-1.jpg 509w, /wp-content/uploads/2021/11/General_Questions-1-1-280x300.jpg 280w"
                      sizes="(max-width: 509px) 100vw, 509px" /></div>
                </div>
              </div>
            </div>
            <div
              class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-54ced4b elementor-invisible"
              data-id="54ced4b" data-element_type="column"
              data-settings="{&quot;animation&quot;:&quot;fadeInRight&quot;}">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div
                  class="elementor-element elementor-element-fbd7ccc elementor-widget__width-inherit elementor-widget elementor-widget-heading"
                  data-id="fbd7ccc" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h3 class="elementor-heading-title elementor-size-default">General Questions</h3>
                  </div>
                </div>
                <div
                  class="elementor-element elementor-element-d096071 elementor-widget__width-auto elementor-widget elementor-widget-heading"
                  data-id="d096071" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h3 class="elementor-heading-title elementor-size-default">Frequently Asked Questions?</h3>
                  </div>
                </div>
                <div class="elementor-element elementor-element-fbaa5f5 elementor-widget elementor-widget-toggle"
                  data-id="fbaa5f5" data-element_type="widget" data-widget_type="toggle.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-toggle" role="tablist">
                      <div class="elementor-toggle-item">
                        <div id="elementor-tab-title-2631" class="elementor-tab-title" data-tab="1" role="tab"
                          aria-controls="elementor-tab-content-2631" aria-expanded="false"> <span
                            class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true"> <span
                              class="elementor-toggle-icon-closed"><i class="fas fa-chevron-right"></i></span> <span
                              class="elementor-toggle-icon-opened"><i
                                class="elementor-toggle-icon-opened fas fa-chevron-up"></i></span> </span> <a href=""
                            class="elementor-toggle-title">How Can I Safely Browse The Internet?</a></div>
                        <div id="elementor-tab-content-2631" class="elementor-tab-content elementor-clearfix"
                          data-tab="1" role="tabpanel" aria-labelledby="elementor-tab-title-2631">Lorem ipsum dolor sit
                          amet
                          consectetuer adipiscing elitenean commo doligula eget dolorenean massaIn enim justo, rhoncus
                          ut,
                          imperdiet avene natis vitae justo nullam dictum felis eu.</div>
                      </div>
                      <div class="elementor-toggle-item">
                        <div id="elementor-tab-title-2632" class="elementor-tab-title" data-tab="2" role="tab"
                          aria-controls="elementor-tab-content-2632" aria-expanded="false"> <span
                            class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true"> <span
                              class="elementor-toggle-icon-closed"><i class="fas fa-chevron-right"></i></span> <span
                              class="elementor-toggle-icon-opened"><i
                                class="elementor-toggle-icon-opened fas fa-chevron-up"></i></span> </span> <a href=""
                            class="elementor-toggle-title">How Does Secuvant's Co-managed Security Model Work?</a></div>
                        <div id="elementor-tab-content-2632" class="elementor-tab-content elementor-clearfix"
                          data-tab="2" role="tabpanel" aria-labelledby="elementor-tab-title-2632">Lorem ipsum dolor sit
                          amet
                          consectetuer adipiscing elitenean commo doligula eget dolorenean massaIn enim justo, rhoncus
                          ut,
                          imperdiet avene natis vitae justo nullam dictum felis eu.</div>
                      </div>
                      <div class="elementor-toggle-item">
                        <div id="elementor-tab-title-2633" class="elementor-tab-title" data-tab="3" role="tab"
                          aria-controls="elementor-tab-content-2633" aria-expanded="false"> <span
                            class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true"> <span
                              class="elementor-toggle-icon-closed"><i class="fas fa-chevron-right"></i></span> <span
                              class="elementor-toggle-icon-opened"><i
                                class="elementor-toggle-icon-opened fas fa-chevron-up"></i></span> </span> <a href=""
                            class="elementor-toggle-title">What Type Frequency Of Alerts And Notifications Will
                            Receive?</a></div>
                        <div id="elementor-tab-content-2633" class="elementor-tab-content elementor-clearfix"
                          data-tab="3" role="tabpanel" aria-labelledby="elementor-tab-title-2633">Lorem ipsum dolor sit
                          amet
                          consectetuer adipiscing elitenean commo doligula eget dolorenean massaIn enim justo, rhoncus
                          ut,
                          imperdiet avene natis vitae justo nullam dictum felis eu.</div>
                      </div>
                      <div class="elementor-toggle-item">
                        <div id="elementor-tab-title-2634" class="elementor-tab-title" data-tab="4" role="tab"
                          aria-controls="elementor-tab-content-2634" aria-expanded="false"> <span
                            class="elementor-toggle-icon elementor-toggle-icon-right" aria-hidden="true"> <span
                              class="elementor-toggle-icon-closed"><i class="fas fa-chevron-right"></i></span> <span
                              class="elementor-toggle-icon-opened"><i
                                class="elementor-toggle-icon-opened fas fa-chevron-up"></i></span> </span> <a href=""
                            class="elementor-toggle-title">How Is Our Data Stored And Protected And For How Long?</a>
                        </div>
                        <div id="elementor-tab-content-2634" class="elementor-tab-content elementor-clearfix"
                          data-tab="4" role="tabpanel" aria-labelledby="elementor-tab-title-2634">Lorem ipsum dolor sit
                          amet
                          consectetuer adipiscing elitenean commo doligula eget dolorenean massaIn enim justo, rhoncus
                          ut,
                          imperdiet avene natis vitae justo nullam dictum felis eu.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> -->
        <section id="products"
          class="elementor-section elementor-top-section elementor-element elementor-element-69974c0 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="69974c0" data-element_type="section"
          data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
          <div class="elementor-background-overlay"></div>
          <div class="elementor-container elementor-column-gap-default">
            <div
              class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-47aa796"
              data-id="47aa796" data-element_type="column">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div
                  class="elementor-element elementor-element-43ef30d elementor-invisible elementor-widget elementor-widget-heading"
                  data-id="43ef30d" data-element_type="widget"
                  data-settings="{&quot;_animation&quot;:&quot;fadeInDown&quot;}" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h3 class="elementor-heading-title elementor-size-default">{{$t('home.products')}}</h3>
                  </div>
                </div>
                <div class="elementor-element elementor-element-6e39a8d elementor-widget elementor-widget-text-editor"
                  data-id="6e39a8d" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container"> {{$t('home.products_desc')}}</div>
                </div>
                <section
                  class="elementor-section elementor-inner-section elementor-element elementor-element-deb535e elementor-section-boxed elementor-section-height-default elementor-section-height-default elementor-invisible"
                  data-id="deb535e" data-element_type="section"
                  data-settings="{&quot;animation&quot;:&quot;fadeInLeft&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div style="margin: 0 auto;"
                      class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-162a2b4"
                      data-id="162a2b4" data-element_type="column"
                      data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-background-overlay"></div>
                        <div
                          class="elementor-element elementor-element-b0c892f elementor-widget__width-auto elementor-widget elementor-widget-image"
                          data-id="b0c892f" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container"> <img width="120" height="120"
                              src="/wp-content/uploads/2021/11/Pricing_Plan-1.png"
                              class="elementor-animation-shrink attachment-large size-large" alt="" loading="lazy" />
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-e2c6868 elementor-widget-tablet__width-inherit elementor-widget elementor-widget-heading"
                          data-id="e2c6868" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h4 class="elementor-heading-title elementor-size-default">{{$t('home.products_1')}}
                            </h4>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-2fe289d elementor-widget__width-auto elementor-widget elementor-widget-heading"
                          data-id="2fe289d" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h3 class="elementor-heading-title elementor-size-default">{{$t('home.products_1_price')}}
                            </h3>
                          </div>
                        </div>
                        <!-- <div
                          class="elementor-element elementor-element-af8abbe elementor-widget__width-auto elementor-widget elementor-widget-heading"
                          data-id="af8abbe" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h6 class="elementor-heading-title elementor-size-default">/Tháng</h6>
                          </div>
                        </div> -->
                        <div
                          class="elementor-element elementor-element-a0fd77b elementor-tablet-align-center elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                          data-id="a0fd77b" data-element_type="widget" data-widget_type="icon-list.default">
                          <div class="elementor-widget-container">
                            <ul class="elementor-icon-list-items">
                              <li class="elementor-icon-list-item"> <span
                                  class="elementor-icon-list-text">{{$t('home.products_1_f_1')}}</span></li>
                              <li class="elementor-icon-list-item"> <span
                                  class="elementor-icon-list-text">{{$t('home.products_1_f_2')}}</span></li>
                              <li class="elementor-icon-list-item"> <span
                                  class="elementor-icon-list-text">{{$t('home.products_1_f_3')}}</span></li>
                              <li class="elementor-icon-list-item"> <span
                                  class="elementor-icon-list-text">{{$t('home.products_1_f_4')}}</span></li>
                            </ul>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-628db2b elementor-widget__width-auto elementor-widget elementor-widget-button"
                          data-id="628db2b" data-element_type="widget" data-widget_type="button.default">
                          <div class="elementor-widget-container">
                            <div class="elementor-button-wrapper"> <a href="#"
                                class="elementor-button-link elementor-button elementor-size-md elementor-animation-float"
                                role="button"> <span class="elementor-button-content-wrapper"> <span
                                    class="elementor-button-text">{{$t('home.products_1_btn')}}</span> </span> </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- <div
                      class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-23b8b35"
                      data-id="23b8b35" data-element_type="column"
                      data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-background-overlay"></div>
                        <div
                          class="elementor-element elementor-element-f632522 elementor-widget__width-auto elementor-widget elementor-widget-image"
                          data-id="f632522" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container"> <img width="120" height="120"
                              src="/wp-content/uploads/2021/11/Pricing_Plan-2.png"
                              class="elementor-animation-shrink attachment-large size-large" alt="" loading="lazy" />
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-5d947f1 elementor-widget-tablet__width-inherit elementor-widget elementor-widget-heading"
                          data-id="5d947f1" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h4 class="elementor-heading-title elementor-size-default">Business</h4>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-9f4b198 elementor-widget__width-auto elementor-widget elementor-widget-heading"
                          data-id="9f4b198" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h3 class="elementor-heading-title elementor-size-default">$39.99</h3>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-b9ea3c3 elementor-widget__width-auto elementor-widget elementor-widget-heading"
                          data-id="b9ea3c3" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h6 class="elementor-heading-title elementor-size-default">/Month</h6>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-aaadbcd elementor-tablet-align-center elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                          data-id="aaadbcd" data-element_type="widget" data-widget_type="icon-list.default">
                          <div class="elementor-widget-container">
                            <ul class="elementor-icon-list-items">
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-text">40 Days
                                  Product
                                  Testing</span></li>
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-text">Upgrade
                                  Anytime
                                  Protection</span></li>
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-text">1000 Malware
                                  Removal</span></li>
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-text">24/7 Live
                                  Assistance</span></li>
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-text">Scan Every 13
                                  Hrs</span></li>
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-text">Configure
                                  Software One-time</span></li>
                            </ul>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-e7b42b6 elementor-widget__width-auto elementor-widget elementor-widget-button"
                          data-id="e7b42b6" data-element_type="widget" data-widget_type="button.default">
                          <div class="elementor-widget-container">
                            <div class="elementor-button-wrapper"> <a href="#"
                                class="elementor-button-link elementor-button elementor-size-md elementor-animation-float"
                                role="button"> <span class="elementor-button-content-wrapper"> <span
                                    class="elementor-button-text">Order Now</span> </span> </a></div>
                          </div>
                        </div>
                      </div>
                    </div> -->
                    <!-- <div
                      class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-eb141d7"
                      data-id="eb141d7" data-element_type="column"
                      data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-background-overlay"></div>
                        <div
                          class="elementor-element elementor-element-dbb943b elementor-widget__width-auto elementor-widget elementor-widget-image"
                          data-id="dbb943b" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container"> <img width="120" height="120"
                              src="/wp-content/uploads/2021/11/Pricing_Plan-3.png"
                              class="elementor-animation-shrink attachment-large size-large" alt="" loading="lazy" />
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-b081650 elementor-widget-tablet__width-inherit elementor-widget elementor-widget-heading"
                          data-id="b081650" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h4 class="elementor-heading-title elementor-size-default">Exclusive</h4>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-8953929 elementor-widget__width-auto elementor-widget elementor-widget-heading"
                          data-id="8953929" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h3 class="elementor-heading-title elementor-size-default">$47.85</h3>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-c1a3a07 elementor-widget__width-auto elementor-widget elementor-widget-heading"
                          data-id="c1a3a07" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h6 class="elementor-heading-title elementor-size-default">/Month</h6>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-794114b elementor-tablet-align-center elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                          data-id="794114b" data-element_type="widget" data-widget_type="icon-list.default">
                          <div class="elementor-widget-container">
                            <ul class="elementor-icon-list-items">
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-text">50 Days
                                  Product
                                  Testing</span></li>
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-text">Upgrade
                                  Anytime
                                  Protection</span></li>
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-text">Unlimited
                                  Malware Removal</span></li>
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-text">24/7 Live
                                  Assistance</span></li>
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-text">Scan Every 14
                                  Hrs</span></li>
                              <li class="elementor-icon-list-item"> <span class="elementor-icon-list-text">Configure
                                  Software One-time</span></li>
                            </ul>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-ce3f3d9 elementor-widget__width-auto elementor-widget elementor-widget-button"
                          data-id="ce3f3d9" data-element_type="widget" data-widget_type="button.default">
                          <div class="elementor-widget-container">
                            <div class="elementor-button-wrapper"> <a href="#"
                                class="elementor-button-link elementor-button elementor-size-md elementor-animation-float"
                                role="button"> <span class="elementor-button-content-wrapper"> <span
                                    class="elementor-button-text">Order Now</span> </span> </a></div>
                          </div>
                        </div>
                      </div>
                    </div> -->
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
        <!-- <section
          class="elementor-section elementor-top-section elementor-element elementor-element-1e4d108 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="1e4d108" data-element_type="section"
          data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
          <div class="elementor-background-overlay"></div>
          <div class="elementor-container elementor-column-gap-default">
            <div
              class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-909fb50"
              data-id="909fb50" data-element_type="column">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div
                  class="elementor-element elementor-element-3dcfe96 elementor-invisible elementor-widget elementor-widget-heading"
                  data-id="3dcfe96" data-element_type="widget"
                  data-settings="{&quot;_animation&quot;:&quot;fadeInDown&quot;}" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h3 class="elementor-heading-title elementor-size-default">Our Professional Team</h3>
                  </div>
                </div>
                <div class="elementor-element elementor-element-62b21f9 elementor-widget elementor-widget-text-editor"
                  data-id="62b21f9" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container"> Lorem ipsum dolor sit amet consectetuer adipiscing elitenean
                    commodo ligula eget dolorenean massa.</div>
                </div>
                <section
                  class="elementor-section elementor-inner-section elementor-element elementor-element-516c30c elementor-section-boxed elementor-section-height-default elementor-section-height-default elementor-invisible"
                  data-id="516c30c" data-element_type="section"
                  data-settings="{&quot;animation&quot;:&quot;fadeInUp&quot;}">
                  <div class="elementor-container elementor-column-gap-default">
                    <div
                      class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-d556ee0"
                      data-id="d556ee0" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-element elementor-element-c6e43b3 elementor-widget elementor-widget-image"
                          data-id="c6e43b3" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container"> <img
                              src="/wp-content/uploads/elementor/thumbs/Team-1-1-pfupvhqv8exnxc8ne6g8gnh6gmaog5ehq6ugimkqjs.jpg"
                              title="Team-1" alt="Team-1" /></div>
                        </div>
                        <div
                          class="elementor-element elementor-element-b5f49cf elementor-widget-tablet__width-inherit elementor-widget elementor-widget-heading"
                          data-id="b5f49cf" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h4 class="elementor-heading-title elementor-size-default">Eric T. Parker</h4>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-19d9978 elementor-widget elementor-widget-text-editor"
                          data-id="19d9978" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container"> Network Security</div>
                        </div>
                        <div
                          class="elementor-element elementor-element-0141dc2 elementor-widget elementor-widget-text-editor"
                          data-id="0141dc2" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container"> Lonec pede justo, fringilla vel, aliquet nec
                            vulputate
                            eget arcu.</div>
                        </div>
                        <div
                          class="elementor-element elementor-element-68864f2 e-grid-align-mobile-center elementor-shape-rounded elementor-grid-0 e-grid-align-center elementor-widget elementor-widget-social-icons"
                          data-id="68864f2" data-element_type="widget" data-widget_type="social-icons.default">
                          <div class="elementor-widget-container">
                            <div class="elementor-social-icons-wrapper elementor-grid"> <span
                                class="elementor-grid-item">
                                <a class="elementor-icon elementor-social-icon elementor-social-icon-facebook-square elementor-animation-float elementor-repeater-item-c218504"
                                  target="_blank"> <span class="elementor-screen-only">Facebook-square</span> <i
                                    class="fab fa-facebook-square"></i> </a> </span> <span class="elementor-grid-item">
                                <a class="elementor-icon elementor-social-icon elementor-social-icon-twitter-square elementor-animation-float elementor-repeater-item-d4fdd66"
                                  target="_blank"> <span class="elementor-screen-only">Twitter-square</span> <i
                                    class="fab fa-twitter-square"></i> </a> </span> <span class="elementor-grid-item">
                                <a class="elementor-icon elementor-social-icon elementor-social-icon-linkedin elementor-animation-float elementor-repeater-item-82e8f72"
                                  target="_blank"> <span class="elementor-screen-only">Linkedin</span> <i
                                    class="fab fa-linkedin"></i> </a> </span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-f929813"
                      data-id="f929813" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-element elementor-element-ea673bc elementor-widget elementor-widget-image"
                          data-id="ea673bc" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container"> <img
                              src="/wp-content/uploads/elementor/thumbs/Team-2-pfuqwo91khtz628ea90z39pkdb1cx509i7tvwng4fc.jpg"
                              title="Team-2" alt="Team-2" /></div>
                        </div>
                        <div
                          class="elementor-element elementor-element-93b2910 elementor-widget-tablet__width-inherit elementor-widget elementor-widget-heading"
                          data-id="93b2910" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h4 class="elementor-heading-title elementor-size-default">Shira Rubinoff</h4>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-3dd48a8 elementor-widget elementor-widget-text-editor"
                          data-id="3dd48a8" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container"> Security Executive</div>
                        </div>
                        <div
                          class="elementor-element elementor-element-9b0a0e6 elementor-widget elementor-widget-text-editor"
                          data-id="9b0a0e6" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container"> Donec pede justo, fringilla vel, aliquet nec
                            vulputate
                            eget arcu.</div>
                        </div>
                        <div
                          class="elementor-element elementor-element-d5cae2e e-grid-align-mobile-center elementor-shape-rounded elementor-grid-0 e-grid-align-center elementor-widget elementor-widget-social-icons"
                          data-id="d5cae2e" data-element_type="widget" data-widget_type="social-icons.default">
                          <div class="elementor-widget-container">
                            <div class="elementor-social-icons-wrapper elementor-grid"> <span
                                class="elementor-grid-item">
                                <a class="elementor-icon elementor-social-icon elementor-social-icon-facebook-square elementor-animation-float elementor-repeater-item-c218504"
                                  target="_blank"> <span class="elementor-screen-only">Facebook-square</span> <i
                                    class="fab fa-facebook-square"></i> </a> </span> <span class="elementor-grid-item">
                                <a class="elementor-icon elementor-social-icon elementor-social-icon-twitter-square elementor-animation-float elementor-repeater-item-d4fdd66"
                                  target="_blank"> <span class="elementor-screen-only">Twitter-square</span> <i
                                    class="fab fa-twitter-square"></i> </a> </span> <span class="elementor-grid-item">
                                <a class="elementor-icon elementor-social-icon elementor-social-icon-linkedin elementor-animation-float elementor-repeater-item-82e8f72"
                                  target="_blank"> <span class="elementor-screen-only">Linkedin</span> <i
                                    class="fab fa-linkedin"></i> </a> </span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-1937058"
                      data-id="1937058" data-element_type="column">
                      <div class="elementor-widget-wrap elementor-element-populated">
                        <div class="elementor-element elementor-element-07f44a9 elementor-widget elementor-widget-image"
                          data-id="07f44a9" data-element_type="widget" data-widget_type="image.default">
                          <div class="elementor-widget-container"> <img
                              src="/wp-content/uploads/elementor/thumbs/RedLight-homepage-ourteam-3-ph5h7qk72s3ny704iyv36e3b1neilw69hjxmspzlns.jpg"
                              title="RedLight-homepage-ourteam-3" alt="RedLight-homepage-ourteam-3" /></div>
                        </div>
                        <div
                          class="elementor-element elementor-element-f04d15d elementor-widget-tablet__width-inherit elementor-widget elementor-widget-heading"
                          data-id="f04d15d" data-element_type="widget" data-widget_type="heading.default">
                          <div class="elementor-widget-container">
                            <h4 class="elementor-heading-title elementor-size-default">Steve Morgan</h4>
                          </div>
                        </div>
                        <div
                          class="elementor-element elementor-element-27e733a elementor-widget elementor-widget-text-editor"
                          data-id="27e733a" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container"> Security Technologist</div>
                        </div>
                        <div
                          class="elementor-element elementor-element-414a812 elementor-widget elementor-widget-text-editor"
                          data-id="414a812" data-element_type="widget" data-widget_type="text-editor.default">
                          <div class="elementor-widget-container"> Ronec pede justo, fringilla vel, aliquet nec
                            vulputate
                            eget arcu.</div>
                        </div>
                        <div
                          class="elementor-element elementor-element-2fbbb89 e-grid-align-mobile-center elementor-shape-rounded elementor-grid-0 e-grid-align-center elementor-widget elementor-widget-social-icons"
                          data-id="2fbbb89" data-element_type="widget" data-widget_type="social-icons.default">
                          <div class="elementor-widget-container">
                            <div class="elementor-social-icons-wrapper elementor-grid"> <span
                                class="elementor-grid-item">
                                <a class="elementor-icon elementor-social-icon elementor-social-icon-facebook-square elementor-animation-float elementor-repeater-item-c218504"
                                  target="_blank"> <span class="elementor-screen-only">Facebook-square</span> <i
                                    class="fab fa-facebook-square"></i> </a> </span> <span class="elementor-grid-item">
                                <a class="elementor-icon elementor-social-icon elementor-social-icon-twitter-square elementor-animation-float elementor-repeater-item-d4fdd66"
                                  target="_blank"> <span class="elementor-screen-only">Twitter-square</span> <i
                                    class="fab fa-twitter-square"></i> </a> </span> <span class="elementor-grid-item">
                                <a class="elementor-icon elementor-social-icon elementor-social-icon-linkedin elementor-animation-float elementor-repeater-item-82e8f72"
                                  target="_blank"> <span class="elementor-screen-only">Linkedin</span> <i
                                    class="fab fa-linkedin"></i> </a> </span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section> -->
        <section id="blog"
          class="elementor-section elementor-top-section elementor-element elementor-element-bd1bc4f elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="bd1bc4f" data-element_type="section"
          data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
          <div class="elementor-background-overlay"></div>
          <div class="elementor-container elementor-column-gap-default">
            <div
              class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-33497ca"
              data-id="33497ca" data-element_type="column">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div
                  class="elementor-element elementor-element-eb9110c elementor-invisible elementor-widget elementor-widget-heading"
                  data-id="eb9110c" data-element_type="widget"
                  data-settings="{&quot;_animation&quot;:&quot;fadeInDown&quot;}" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <a href="https://github.com/CyberZ-vn/blog/issues" target="_blank" rel="noopener noreferrer">
                      <h3 class="elementor-heading-title elementor-size-default">{{$t('home.blog')}}</h3>
                    </a>
                  </div>
                </div>
                <div class="elementor-element elementor-element-bcf10cc elementor-widget elementor-widget-text-editor"
                  data-id="bcf10cc" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container"> {{$t('home.blog_desc')}}
                  </div>
                </div>
                <div
                  class="elementor-element elementor-element-25ad664 elementor-invisible elementor-widget elementor-widget-elementskit-blog-posts"
                  data-id="25ad664" data-element_type="widget"
                  data-settings="{&quot;_animation&quot;:&quot;fadeInUp&quot;}"
                  data-widget_type="elementskit-blog-posts.default">
                  <div class="elementor-widget-container">
                    <div class="ekit-wid-con">
                      <div id="post-items--25ad664" class="row post-items">
                        <!-- loop -->
                        <div class="col-lg-4 col-md-6" style="margin-bottom: 25px;" v-for="p in latestPosts"
                          :key="p.id">
                          <div style="height: 100%;" class="elementskit-post-image-card">
                            <div class="elementskit-entry-header"> <a style="text-align: center;" target="_blank"
                                :href="p.html_url" class="elementskit-entry-thumb"> <img :src="getFeatureImage(p.body)"
                                  style="height: 200px; width: auto !important;"> </a></div>
                            <div class="elementskit-post-body ">
                              <h2 class="entry-title"> <a target="_blank" :href="p.html_url">
                                  {{p.title}} </a></h2>
                              <p>by @{{p.user.login}}</p>
                            </div>
                          </div>
                        </div>
                        <!-- /loop -->

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- <section
          class="elementor-section elementor-top-section elementor-element elementor-element-d20cde1 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="d20cde1" data-element_type="section"
          data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
          <div class="elementor-background-overlay"></div>
          <div class="elementor-container elementor-column-gap-default">
            <div
              class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4b4403e"
              data-id="4b4403e" data-element_type="column"
              data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
              <div class="elementor-widget-wrap elementor-element-populated">
                <div class="elementor-background-overlay"></div>
                <div
                  class="elementor-element elementor-element-acceba6 elementor-invisible elementor-widget elementor-widget-heading"
                  data-id="acceba6" data-element_type="widget"
                  data-settings="{&quot;_animation&quot;:&quot;fadeInDown&quot;}" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h3 class="elementor-heading-title elementor-size-default">Subscribe Our Newsletter</h3>
                  </div>
                </div>
                <div class="elementor-element elementor-element-8fd202d elementor-widget elementor-widget-text-editor"
                  data-id="8fd202d" data-element_type="widget" data-widget_type="text-editor.default">
                  <div class="elementor-widget-container"> Lorem ipsum dolor sit amet consectetuer adipiscing elitenean
                    commodo ligula eget dolorenean massa.</div>
                </div>
                <div
                  class="elementor-element elementor-element-a03d742 elementor-widget elementor-widget-metform animated fadeInUp"
                  data-id="a03d742" data-element_type="widget"
                  data-settings="{&quot;_animation&quot;:&quot;fadeInUp&quot;}" data-widget_type="metform.default">
                  <div class="elementor-widget-container">
                    <div id="mf-response-props-id-1591" data-editswitchopen=""
                      data-erroricon="fas fa-exclamation-triangle" data-successicon="fas fa-check"
                      data-messageposition="top" class=" mf-scroll-top-no">
                      <div class="formpicker_warper formpicker_warper_editable" data-metform-formpicker-key="1591">
                        <div class="elementor-widget-container">
                          <div id="metform-wrap-a03d742-1591" class="mf-form-wrapper" data-form-id="1591"
                            data-action="https://elementorpress.com/templatekit-pro/layout24/wp-json/metform/v1/entries/insert/1591"
                            data-wp-nonce="f1f500f84e" data-form-nonce="97d9719a5e" data-stop-vertical-effect="">
                            <form class="metform-form-content">
                              <div class="mf-main-response-wrap   mf-response-msg-wrap" data-show="0">
                                <div class="mf-response-msg"></div>
                              </div>
                              <div class="metform-form-main-wrapper">
                                <div data-elementor-type="wp-post" data-elementor-id="1591"
                                  class="elementor elementor-1591" data-elementor-settings="[]">
                                  <div class="elementor-section-wrap">
                                    <section
                                      class="elementor-section elementor-top-section elementor-element elementor-element-1f80d39 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                      data-id="1f80d39" data-element_type="section">
                                      <div class="elementor-container elementor-column-gap-default">
                                        <div
                                          class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-a76d68d"
                                          data-id="a76d68d" data-element_type="column"
                                          data-settings="{&amp;quot;background_background&amp;quot;:&amp;quot;classic&amp;quot;}">
                                          <div class="elementor-widget-wrap elementor-element-populated">
                                            <div
                                              class="elementor-element elementor-element-7be7ad8 elementor-widget__width-auto elementor-widget elementor-widget-mf-email"
                                              data-id="7be7ad8" data-element_type="widget"
                                              data-settings="{&amp;quot;mf_input_name&amp;quot;:&amp;quot;mf-email&amp;quot;}"
                                              data-widget_type="mf-email.default">
                                              <div class="elementor-widget-container">
                                                <div class="mf-input-wrapper"><input type="email" class="mf-input "
                                                    id="mf-input-email-7be7ad8" name="mf-email"
                                                    placeholder="Enter Your Email " aria-invalid="false" value=""></div>
                                              </div>
                                            </div>
                                            <div
                                              class="elementor-element elementor-element-d700f44 elementor-widget__width-auto mf-btn--center elementor-widget elementor-widget-mf-button"
                                              data-id="d700f44" data-element_type="widget"
                                              data-widget_type="mf-button.default">
                                              <div class="elementor-widget-container">
                                                <div class="mf-btn-wraper "
                                                  data-mf-form-conditional-logic-requirement=""><button type="submit"
                                                    class="metform-btn metform-submit-btn " id=""><span>Subscibe
                                                    </span></button></div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </section>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> -->
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'HomeView',
    data() {
      return {
        latestPosts: []
      }
    },
    watch: {
      '$i18n.locale'() {
        this.$nextTick(this.getLatestPosts.bind(this))
      }
    },
    created() {
      this.getLatestPosts()
    },
    mounted() {
      if (window.initPage) {
        window.initPage()
        window.initPage = null
      }
    },
    methods: {
      getLatestPosts() {
        const repo = 'CyberZ-vn/blog'
        fetch('https://api.github.com/repos/' + repo + '/issues?sort=created&state=all&per_page=6&page=1&filter=all&direction=desc&labels=' + (this.$i18n.locale || 'vi')).then(r => r.json()).then(r => {
          this.latestPosts = r
        })
      },
      getFeatureImage(body) {
        const m = /!\[.*?\]\((.*?)\)/.exec(body)
        if (!m) return '/wp-content/uploads/2021/11/Blog-2.jpg'
        return m[1]
      }
    }
  }
</script>

<style>
  .ablog-title:hover {
    color: var(--e-global-color-accent);
  }

  .ablog-title {
    -webkit-transition: all .4s ease;
    transition: all .4s ease;
    text-transform: none;
    font-weight: 500;
    letter-spacing: normal;
  }
</style>